import React, { Component } from 'react';
import Loading from './Loading';
import { _Alert, variable, _post, _getToken, _isLogin, _setTime } from './Function';
import '../css/Deposit.css';

class DepositAccount extends Component {
    constructor(props) {
        super(props);
        this.state={ 
            loadingShow: true,
            account: [],
            is_account: true
        };
        _isLogin().then( value => { 
            if ( value ) this.getDeposit();
        });
    }

    gotoTransaction(id) {
        window.location.href = variable().BASE_URL + "/online/deposit/" + id;
    }

    getDeposit() {
        let param = { token: _getToken(), platform: variable().platform };
        _post('get.deposit.account.php', param)
        .then(res => { 
            if ( res.data.status ) {
                this.setState({ account: res.data.data, loadingShow: false });
            } else {
                this.setState({ loadingShow: false, is_account: false });
                if ( res.data.responseText === 101 ) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                }
            }   
        }).catch(err => { 
            this.setState({ loadingShow: false });
            _Alert('error'); 
        });
    }

    renderDeposit() {
        return (
            <div>
                <table className="table table-deposit table-deposit-account">
                    <thead>
                        {
                            ( this.state.account.length > 0 ) ?
                                <tr>
                                    <th scope="col" width="10%">เลขบัญชี</th>
                                    <th scope="col">ชื่อบัญชี</th>
                                    <th scope="col">ประเภทบัญชี</th>
                                    <th scope="col">ยอดเงินคงเหลือ</th>
                                </tr>
                            :
                                null
                        }
                    </thead>
                    <tbody>   
                    {
                        this.state.account.map(account => (
                            <tr key={account.account_id} onClick={(e) => this.gotoTransaction(account.account_id)}>
                                <td>{account.account_id}</td>
                                <td>{account.account_name}</td>
                                <td className="td-type">{account.account_type}</td>
                                <td className="money">{account.balance} บาท</td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table> 

                <div className="mobile-content">
                    {
                        this.state.account.map((account, index) => (
                            <div key={account.account_id} onClick={(e) => this.gotoTransaction(account.account_id)} className={(index === 0) ? 'deposit-loop is-first' : 'deposit-loop'}>
                                <div className="deposit-row">
                                    <div className="deposit-row-first"><span className="text-title">เลขบัญชี : </span><span className="text-desc">{account.account_id}</span></div>
                                    <div className="deposit-row-second"><span className="text-title">ชื่อบัญชี : </span><span className="text-desc">{account.account_name}</span></div>
                                </div>
                                <div className="deposit-row">
                                    <div className="deposit-row-third"><span className="text-title">ประเภทบัญชี : </span><span className="text-desc type-desc">{account.account_type}</span></div>
                                    <div className="deposit-row-fourt"><span className="text-title">ยอดเงินคงเหลือ : </span><span className="text-desc">{account.balance} บาท</span></div>
                                </div>
                            </div> 
                        ))
                    }
                </div>
            </div>
        );
    }

    render() {
        return(
            <div>
                <Loading show={this.state.loadingShow} />
                <div className="card">
                    <div className="card-title">
                        <div className="card-icon"><i className="fas fa-dollar-sign"></i></div>
                        <div className="card-title-text">เงินฝาก</div>
                    </div>
                    <div className="card-content">
                        {
                            (this.state.is_account) ?
                                this.renderDeposit()
                            :
                                <div className="no-data">ไม่พบบัญชีเงินฝาก</div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default DepositAccount;
